// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
    background-color: #f5f5f5;
    width: 600px;
    min-width: 600px;
    max-width: 600px;
    overflow-y: auto;
    max-height: 400px;
    min-height: 400px;
}
.error {
    font-size: 13px;
    color: #d32f2f;
}
.doclist-wrapper {
    margin-right: 2em;
}
.doc-header {
    background-color: #fff;
    height: 9px;
    border-bottom: 1px solid #eaeaea;
    margin-right: 2em;
    position: fixed;
    transition: border-color .2s, box-shadow .2s;
    z-index: 5;
}
.doc-header.shadow {
    border-color: #eaeaea;
    box-shadow: 0 4px 6px -2px rgba(0,0,0,.04);
}
.doclist {
    list-style: none;
    margin: 9px 0 0;
    padding: 0;
}
.doclist li {
    padding: 5px 10px;
}
.doclist a {
    cursor: pointer;
}
.doclist a.selectedPath {
    color: #00bed6;
}
.doclist i {
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
}
.file-avatar-icon img {
    display: block;
    width: 32px;
    height: 32px;
    object-fit: contain;
}
.file-avatar-icon img.cover {
    object-fit: cover;
}
.file-avatar img {
    display: block;
    margin: 10px;
    width: 32px;
    height: 32px;
    object-fit: contain;
}
.file-avatar img.cover {
    object-fit: cover;
}
.file-filename {
    padding: 6px 0;
    max-width: 50%;
}
.file-filename a {
    cursor: pointer;
}
.selected .file-username a, .selected .file-username span {
    color: #1a5976;
}
.mat-dialog-content {
    overflow: hidden;
}
.mat-dialog-title {
    font-size: 18px;
    word-break: break-all;
    width: 600px;
}
i:not(.caret):before {
    vertical-align: middle;
}
i.caret {
    cursor: default;
    font-size: inherit;
    left: 0;
    transition: transform .4s;
}
.expanded {
    transform: rotate(90deg);
}
.doclist a.denied {
    cursor: default;
    color: #a7a6a6;
    text-decoration: none;
}
.denied img {
    filter: grayscale(100%);
    opacity: .8;
}
img {
    width: 20px;
    height: 20px;
    vertical-align: top;
}
app-folders {
   display: block;
   margin-left: 18px;
}
::ng-deep .mat-button:hover .mat-button-focus-overlay{
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/move/move.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;IACf,4CAA4C;IAC5C,UAAU;AACd;AACA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,OAAO;IACP,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;GACG,cAAc;GACd,iBAAiB;AACpB;AACA;GACG,wBAAwB;AAC3B","sourcesContent":[".main {\n    background-color: #f5f5f5;\n    width: 600px;\n    min-width: 600px;\n    max-width: 600px;\n    overflow-y: auto;\n    max-height: 400px;\n    min-height: 400px;\n}\n.error {\n    font-size: 13px;\n    color: #d32f2f;\n}\n.doclist-wrapper {\n    margin-right: 2em;\n}\n.doc-header {\n    background-color: #fff;\n    height: 9px;\n    border-bottom: 1px solid #eaeaea;\n    margin-right: 2em;\n    position: fixed;\n    transition: border-color .2s, box-shadow .2s;\n    z-index: 5;\n}\n.doc-header.shadow {\n    border-color: #eaeaea;\n    box-shadow: 0 4px 6px -2px rgba(0,0,0,.04);\n}\n.doclist {\n    list-style: none;\n    margin: 9px 0 0;\n    padding: 0;\n}\n.doclist li {\n    padding: 5px 10px;\n}\n.doclist a {\n    cursor: pointer;\n}\n.doclist a.selectedPath {\n    color: #00bed6;\n}\n.doclist i {\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n    text-align: center;\n}\n.file-avatar-icon img {\n    display: block;\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n}\n.file-avatar-icon img.cover {\n    object-fit: cover;\n}\n.file-avatar img {\n    display: block;\n    margin: 10px;\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n}\n.file-avatar img.cover {\n    object-fit: cover;\n}\n.file-filename {\n    padding: 6px 0;\n    max-width: 50%;\n}\n.file-filename a {\n    cursor: pointer;\n}\n.selected .file-username a, .selected .file-username span {\n    color: #1a5976;\n}\n.mat-dialog-content {\n    overflow: hidden;\n}\n.mat-dialog-title {\n    font-size: 18px;\n    word-break: break-all;\n    width: 600px;\n}\ni:not(.caret):before {\n    vertical-align: middle;\n}\ni.caret {\n    cursor: default;\n    font-size: inherit;\n    left: 0;\n    transition: transform .4s;\n}\n.expanded {\n    transform: rotate(90deg);\n}\n.doclist a.denied {\n    cursor: default;\n    color: #a7a6a6;\n    text-decoration: none;\n}\n.denied img {\n    filter: grayscale(100%);\n    opacity: .8;\n}\nimg {\n    width: 20px;\n    height: 20px;\n    vertical-align: top;\n}\napp-folders {\n   display: block;\n   margin-left: 18px;\n}\n::ng-deep .mat-button:hover .mat-button-focus-overlay{\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
